<app-list-module-table
  variant="surface"
  [columns]="columns"
  [rows]="rows"
  [loading]="loading"
  [emptyMessage]="emptyMessage"
>
  <ng-template listCellDef="date" let-row="row">
    <div class="text-sm font-medium text-gray-900 dark:text-white">{{ row.created_at | date : 'dd MMM y' }}</div>
    <div class="text-xs text-gray-400">{{ row.created_at | date : 'HH:mm:ss' }}</div>
  </ng-template>

  <ng-template listCellDef="action" let-row="row">
    <span class="inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold" [class]="chipClass(row)">
      {{ label(row) }}
    </span>
  </ng-template>

  <ng-template listCellDef="resource" let-row="row">
    <span [title]="row.resource_type ?? ''">{{ record(row) }}</span>
  </ng-template>

  <ng-template listCellDef="actor" let-row="row">
    <span class="block truncate" [title]="actor(row)">{{ actor(row) }}</span>
    <span class="block text-xs text-gray-400">{{ row.actor_type }}</span>
  </ng-template>

  <ng-template listCellDef="origin" let-row="row">
    <span class="block font-mono">{{ row.source_ip || '—' }}</span>
    <span class="block text-gray-400">{{ client(row) }}</span>
  </ng-template>

  <ng-template listCellDef="outcome" let-row="row">
    <span class="inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold" [class]="outcomeClass(row)">
      {{ row.outcome === 'failure' ? 'Failed' : 'Done' }}
    </span>
  </ng-template>

  <ng-template listCellDef="actions" let-row="row">
    <button
      type="button"
      class="inline-flex h-9 w-9 items-center justify-center rounded-lg text-primary hover:bg-primary/10"
      title="View details"
      aria-label="View details"
      (click)="view.emit(row)"
    >
      <icon-eye class="h-4 w-4" />
    </button>
  </ng-template>
</app-list-module-table>
